var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKdsPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#EDF9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 3.05556,
    height: 6.875,
    rx: 0.763889,
    fill: "#0085E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.0557,
    y: 12,
    width: 3.05556,
    height: 5.34722,
    rx: 0.763889,
    fill: "#0085E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 10.5C26 9.6875 25.3125 9 24.5 9H7.5C6.65625 9 6 9.6875 6 10.5V21.5C6 22.3438 6.65625 23 7.5 23H24.5C25.3125 23 26 22.3438 26 21.5V10.5ZM24.5 10.5V21.5H7.5V10.5H24.5Z",
    fill: "#0085E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdsPrimary);
export default __webpack_public_path__ + "static/media/kds-primary.b84225d6.svg";
export { ForwardRef as ReactComponent };